import React from 'react'
import Image from 'next/image'
import PropTypes from 'prop-types'

import Text from '../../../common/Text'

import styles from './LogoMarquee.module.scss'

const logos = [
  { type: 'image', src: '/home2/forbes.png', alt: 'Forbes' },
  { type: 'image', src: '/home2/wired.png', alt: 'Wired' },
  { type: 'image', src: '/home2/techcrunch2.png', alt: 'TechCrunch' },
  { type: 'image', src: '/home2/inc.png', alt: 'Inc' },
  { type: 'image', src: '/home2/entrepreneur.png', alt: 'Entrepreneur' },
]

function LogoItem({ logo }) {
  return (
    <div className={styles.logoItem}>
      <Image alt={logo.alt} height={24} src={logo.src} style={{ objectFit: 'contain' }} width={120} />
    </div>
  )
}

export default function LogoMarquee({ t }) {
  const track = [
    ...logos.map((logo) => ({ ...logo, copy: 'a' })),
    ...logos.map((logo) => ({ ...logo, copy: 'b' })),
  ]

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <Text className={styles.label}>{t.title}</Text>
        <div className={styles.marqueeWrap}>
          <div className={styles.fadeLeft} />
          <div className={styles.fadeRight} />
          <div className={styles.marqueeTrack}>
            {track.map((logo) => (
              <LogoItem key={`${logo.src}-${logo.copy}`} logo={logo} />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

LogoItem.propTypes = {
  logo: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
}

LogoMarquee.propTypes = {
  t: PropTypes.shape({
    title: PropTypes.string.isRequired,
  }).isRequired,
}
